import ReactPlayer from 'react-player';
import React, { useEffect, useState } from 'react';
import {
  MediaController,
  MediaControlBar,
  MediaTimeRange,
  MediaTimeDisplay,
  MediaVolumeRange,
  MediaPlaybackRateButton,
  MediaPlayButton,
  MediaMuteButton,
  MediaFullscreenButton,
} from 'media-chrome/react';

export default function VideoPlayer({ videoUrl }) {
  const negateHeight = 400;
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight - negateHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setDimensions({
        height: window.innerHeight - negateHeight,
      });
    };
    window.addEventListener('resize', handleResize);
  }, []);

  return (
    <div onContextMenu={e => e.preventDefault()}>
      <MediaController
        style={{
          width: '100%',
          height: dimensions.height,
          aspectRatio: '16/9',
          '@media print': {
            embed: {
              display: 'none !important',
            },
          },
        }}>
        <ReactPlayer
          slot="media"
          src={videoUrl}
          controls={false}
          style={{
            width: '100%',
            height: dimensions.height,
            '--controls': 'none',
          }}
        />
        <MediaControlBar>
          <MediaPlayButton />
          <MediaTimeRange />
          <MediaTimeDisplay showDuration />
          <MediaMuteButton />
          <MediaVolumeRange />
          <MediaPlaybackRateButton />
          <MediaFullscreenButton />
        </MediaControlBar>
      </MediaController>
    </div>
  );
}
